/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Signin_Resend_ReasonInputs */

const en_signin_resend_reason = /** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can resend the link in ${i?.seconds} seconds.`)
};

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const ar_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const he_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const ur_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const es_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const fr_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const de_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const pt_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const hi_signin_resend_reason = en_signin_resend_reason;

/** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */
const bn_signin_resend_reason = en_signin_resend_reason;

/**
* | output |
* | --- |
* | "You can resend the link in {seconds} seconds." |
*
* @param {Signin_Resend_ReasonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_resend_reason = /** @type {((inputs: Signin_Resend_ReasonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Resend_ReasonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_resend_reason(inputs)
	if (locale === "he") return he_signin_resend_reason(inputs)
	if (locale === "ur") return ur_signin_resend_reason(inputs)
	if (locale === "es") return es_signin_resend_reason(inputs)
	if (locale === "fr") return fr_signin_resend_reason(inputs)
	if (locale === "de") return de_signin_resend_reason(inputs)
	if (locale === "pt") return pt_signin_resend_reason(inputs)
	if (locale === "hi") return hi_signin_resend_reason(inputs)
	if (locale === "bn") return bn_signin_resend_reason(inputs)
	return en_signin_resend_reason(inputs)
});